module.exports = __webpack_public_path__ + "a69b6265a22c9ecbb512d11053baa16a.jpg";